import isEqual from 'lodash/isEqual'

const DAYS_OF_WEEK = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

export function formatDaysOfWeek(daysOfWeek: boolean[]) {
  if (daysOfWeek.every(day => !day)) return null

  // Special case, format MTWTF as 'Mon – Fri'
  if (isEqual(daysOfWeek, [false, true, true, true, true, true, false])) return 'Mon – Fri'

  return daysOfWeek
    .map((day, index) => day && DAYS_OF_WEEK[index])
    .filter(day => day)
    .join(', ')
}
